import FullScreenOverlay from '../../../Components/FullScreenOverlay/FullScreenOverlay';
import { get, post } from '../../../Services/api';
import loading_display from '../../../Utility/loading_display';
import './SelectedMealModal.css'


function SelectedMealModal({ selected_meals, mealsSelectedAction, setMealsSelectedAction, selectedMealFunc, checkMealChecked, getAllSelectedMeals }) {

    async function setActiveStatus(status) {
        if (window.confirm('Are you sure?')) {
            loading_display(true)
            // set activate status
            const result = await post('/api/admin/meal/set-meal-active-flag?is_active=' + status, {
                meal_id_array: selected_meals.map((meal) => meal.meal_id)
            })
            // get all meals again
            await getAllSelectedMeals()

            loading_display(false)
        }
    }

    async function setSubStatus(status) {
        if (window.confirm('Are you sure?')) {
            loading_display(true)
            // set subscriber status
            const result = await post('/api/admin/meal/set-meal-sub-flag?subscribers_only=' + status, {
                meal_id_array: selected_meals.map((meal) => meal.meal_id)
            })
            // get all meals again
            await getAllSelectedMeals()

            loading_display(false)
        }
    }

    console.log(selected_meals)

    async function generateImage(all_meals) {
        if (window.confirm('Are you sure?')) {
            loading_display(true)
            for (let i = 0; i < selected_meals.length; i++) {
                const meal = selected_meals[i]

                if (all_meals || !meal.image) {
                    // generate image
                    const result = await get('/api/admin/meal/generate-meal-image?meal_name=' + meal.name + '&meal_id=' + meal.meal_id + "&meal_cuisine=" + meal.cuisines + '&meal_course=' + meal.courses)
                }
            }
            // get all meals again
            await getAllSelectedMeals()

            loading_display(false)
        }
    }

    async function generateInstructions() {
        if (window.confirm('Are you sure?')) {
            loading_display(true)

            for (let i = 0; i < selected_meals.length; i++) {
                const meal = selected_meals[i]

                // regenerate instructions
                const result = await post('/api/admin/meal/regenerate-meal-instructions', { meal_name: meal.name, meal_id: meal.meal_id, cuisine: meal.cuisines })
                console.log(result)
                if (result.message != "meals regenerated")
                    alert('Error generating instructions for: ' + meal.name)
            }
            // get all meals again
            await getAllSelectedMeals()

            loading_display(false)
        }
    }

    async function generateRecipe() {
        if (window.confirm('Are you sure?')) {
            loading_display(true)
            for (let i = 0; i < selected_meals.length; i++) {
                const meal = selected_meals[i]

                // generate recipe
                const result = await post('/api/admin/meal/regenerate-recipes?meal_name=' + meal.name + '&meal_id=' + meal.meal_id)
                if (result.message != "success")
                    alert('Error generating recipe')
            }
            // get all meals again
            await getAllSelectedMeals()

            loading_display(false)
        }
    }

    async function deleteMeal() {
        if (window.confirm('Are you sure?')) {
            loading_display(true)
            try {
                // set subscriber status
                const result = await post('/api/admin/meal/delete-meal', {
                    meal_id_array: selected_meals.map((meal) => meal.meal_id)
                })

                if (result.meals) alert('Error deleting meal. These meals are in use: ' + result.meals)
            } catch (error) {
                console.log(error)
                alert('Error deleting meal. Most likely it is in use by a user.')
            }

            // get all meals again
            await getAllSelectedMeals()

            loading_display(false)
        }
    }

    return (
        <div>
            <FullScreenOverlay modalOpen={mealsSelectedAction} setModalOpen={setMealsSelectedAction}>
                <div className='admin_meals_selected_meals_action_div'>
                    <div className="flex gap_12">
                        <div className='flex flex_column gap_6'>
                            <button className="admin_meals_indiv_meal_action_button cursor_pointer" onClick={() => setActiveStatus(true)}>Activate All</button>
                            <button className="admin_meals_indiv_meal_action_button cursor_pointer" onClick={() => setActiveStatus(false)}>Deactivate All</button>
                        </div>
                        <div className='flex flex_column gap_6'>
                            <button className="admin_meals_indiv_meal_action_button cursor_pointer" onClick={() => setSubStatus(true)}>Subscribers Only</button>
                            <button className="admin_meals_indiv_meal_action_button cursor_pointer" onClick={() => setSubStatus(false)}>All Users</button>
                        </div>
                        <div className='flex flex_column gap_6'>
                            <button className="admin_meals_indiv_meal_action_button cursor_pointer" onClick={() => generateImage(true)}>Generate Image For All</button>
                            <button className="admin_meals_indiv_meal_action_button cursor_pointer" onClick={() => generateImage(false)}>Generate Image For Ones With No Image</button>
                        </div>
                        <div className='flex flex_column gap_6'>
                            <button className="admin_meals_indiv_meal_action_button cursor_pointer" onClick={() => generateInstructions()}>Generate Instructions</button>
                        </div>

                        <div className='flex flex_column gap_6'>
                            <p className='admin_meals_indiv_filter_attention_selected' onClick={() => deleteMeal()}>Delete Meals</p>
                        </div>
                    </div>

                    <div className='admin_meals_selected_meals_action_div_meal_list'>
                        <div className='gray_scale_1 admin_meals_list_indiv_meal'>
                            <p></p>
                            <p className='font_size_16'>Image</p>
                            <p className='font_size_16'>Name</p>
                            <p className='font_size_16'>Cuisine</p>
                            <p className='font_size_16'>Course</p>
                            <p className='font_size_16'>Ingr.</p>
                            <p className='font_size_16'>Recipe</p>
                            <p className='font_size_16'>Status</p>
                            <p className='font_size_16'>Open to</p>
                        </div>
                        {selected_meals.map((meal, i) => (
                            <div key={i} className='admin_meals_selected_meals_action_div_meal_list_indiv'>
                                <input onChange={(e) => selectedMealFunc(meal, e.target.checked)} checked={checkMealChecked(meal)} type='checkbox' className='admin_meals_list_indiv_meal_checkbox cursor_pointer' />

                                {meal.image ? <img src={meal.image} className='admin_meals_list_indiv_meal_img' /> : <div></div>}

                                <p className='gray_scale_1 font_size_20 word_break'>{meal.name}</p>

                                <p className='gray_scale_1 font_size_16 word_break'>{meal.cuisines}</p>
                                <p className='gray_scale_1 font_size_16 word_break'>{meal.courses}</p>
                                <p className='gray_scale_1 font_size_16 word_break'>{meal.ingredient_count}</p>
                                <p className='gray_scale_1 font_size_16 word_break'>{meal.recipe_count}</p>
                                <p className={'font_size_16 text_align_center ' + (meal.is_active ? 'admin_meals_list_indiv_meal_active' : 'admin_meals_list_indiv_meal_inactive')}>
                                    {meal.is_active ? 'Active' : 'Inactive'}
                                </p>
                                <p className={'font_size_16 text_align_center ' + (meal.subscribers_only ? 'admin_meals_list_indiv_meal_subscribers' : 'admin_meals_list_indiv_meal_all')}>
                                    {meal.subscribers_only ? 'Subscribers' : 'All users'}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </FullScreenOverlay>
        </div>
    );
}


export default SelectedMealModal;